var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJsonwebtokens = function SvgJsonwebtokens(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "101px",
    height: "101px",
    viewBox: "0 0 101 101"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jsonwebtokens_svg__Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jsonwebtokens_svg__jwt_logo",
    transform: "translate(-150.000000, -538.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jsonwebtokens_svg__Group",
    transform: "translate(0.000000, 413.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.000000, 125.000000)",
    id: "jsonwebtokens_svg__Shape"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.8,27.2 L57.7,0.3 L42.7,0.3 L42.8,27.2 L50.3,37.5 L57.8,27.2 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8,73.3 L42.8,100.3 L57.8,100.3 L57.8,73.3 L50.3,63 L42.8,73.3 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8,73.3 L73.6,95.1 L85.7,86.3 L69.9,64.5 L57.8,60.6 L57.8,73.3 Z",
    fill: "#00F2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8,27.2 L26.9,5.4 L14.8,14.2 L30.6,36 L42.8,39.9 L42.8,27.2 Z",
    fill: "#00F2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6,36 L5,27.7 L0.4,41.9 L26,50.3 L38.1,46.3 L30.6,36 Z",
    fill: "#00B9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4,54.2 L69.9,64.5 L95.5,72.8 L100.1,58.6 L74.5,50.3 L62.4,54.2 Z",
    fill: "#00B9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,50.3 L100.1,41.9 L95.5,27.7 L69.9,36 L62.4,46.3 L74.5,50.3 Z",
    fill: "#D63AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,50.3 L0.4,58.6 L5,72.8 L30.6,64.5 L38.1,54.2 L26,50.3 Z",
    fill: "#D63AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6,64.5 L14.8,86.3 L26.9,95.1 L42.8,73.3 L42.8,60.6 L30.6,64.5 Z",
    fill: "#FB015B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9,36 L85.7,14.2 L73.6,5.4 L57.8,27.2 L57.8,39.9 L69.9,36 Z",
    fill: "#FB015B"
  }))))))));
};
export default SvgJsonwebtokens;